import React from "react";
import SignupWithGoogle from "./signupWithGoogle";
import Signup_sidebar from "./Signup_sidebar";
import AlertPopup from "./alertPopup";
import { useObserver } from "mobx-react";
export default function SignupPage2() {
  return useObserver(() => {
    return (
      <div className="flex h-screen gil-reg">
        <AlertPopup></AlertPopup>
        {/* First Half - Sidebar (Hidden in Mobile) */}
        <div className="w-[50%] md:w-[50%] lg:w-[50%]  hidden lg:block md:block bg-black">
          <Signup_sidebar></Signup_sidebar>
        </div>

        {/* Second Half - Signup with Google */}
        <div className="w-full md:w-[50%] lg:w-1/2  overflow-auto scrollbar-hidden ">
          <SignupWithGoogle></SignupWithGoogle>
        </div>
      </div>
    );
  });
}
